export const MAX_ADDITIONAL_COMMENT_LENGTH = 2000;

export const additionalDetailsActive = (question, answer = {}) => {
  const config = question?.additional_details;
  if (config?.enabled !== true) return false;
  if (question.answer_type === "text") {
    return Boolean(String(answer.answer_text ?? answer.answer_value ?? "").trim());
  }
  return Array.isArray(config.answer_values) &&
    config.answer_values.includes(answer.answer_value);
};

export const additionalCommentPayload = (question, answer = {}) =>
  additionalDetailsActive(question, answer)
    ? { additional_comment: String(answer.additional_comment || "").trim() }
    : {};

export const additionalCommentValid = (question, answer = {}) => {
  if (!additionalDetailsActive(question, answer)) return true;
  const comment = String(answer.additional_comment || "").trim();
  return comment.length <= MAX_ADDITIONAL_COMMENT_LENGTH &&
    (!question.additional_details.required || comment.length > 0);
};

export const updateQuestionAnswer = (question, previous, patch) => {
  const next = { ...previous, ...patch };
  if (!additionalDetailsActive(question, next)) delete next.additional_comment;
  return next;
};
